import { render, staticRenderFns } from "./chelianglayunbaobiao.vue?vue&type=template&id=4c1d642b&scoped=true&"
import script from "./chelianglayunbaobiao.vue?vue&type=script&lang=js&"
export * from "./chelianglayunbaobiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1d642b",
  null
  
)

export default component.exports